import { API_URL } from '../../../app-config/constants';
import { ChatHistory, UserRating } from '../../react/features/AiCopilot/types';
import { ChatHistoryDto } from '../../react/features/CompanyObserver/pages/AiObserver/types';
import { get, post, remove } from '../request';

const BASE_URL = `${API_URL}/copilot/history`;

getHistory.operation = 'READ';
export function getHistory(query?: { assistantId?: string; reviewId?: string }) {
    return get<ChatHistory[]>(BASE_URL, {
        getData: query,
    });
}

getChat.operation = 'READ';
export function getChat(id: string) {
    return get<ChatHistory>(`${BASE_URL}/${id}`);
}

rateAiResponse.operation = 'COMMAND';
export function rateAiResponse(id: string, historyItemId: string, userRating: UserRating) {
    return post<ChatHistory>(`${BASE_URL}/${id}/${historyItemId}`, { postData: userRating });
}

deleteChat.operation = 'DELETE';
export function deleteChat(id: string) {
    return remove(`${BASE_URL}/${id}`);
}

getCompanyObserverHistory.operation = 'READ';
export function getCompanyObserverHistory(companyId: string) {
    return get<ChatHistoryDto[]>(`${API_URL}/ai-observer/company/${companyId}/chat-history`);
}

getUserObserverHistory.operation = 'READ';
export function getUserObserverHistory(userId: string) {
    return get<ChatHistoryDto[]>(`${API_URL}/ai-observer/user/${userId}/chat-history`);
}
